import { createFileRoute } from "@tanstack/react-router";
import { Mail } from "lucide-react";
import { SiteHeaderEn } from "@/components/SiteHeaderEn";
import { SiteFooterEn } from "@/components/SiteFooterEn";
import { LeadForm } from "@/components/LeadForm";

const SITE = "https://shopify-freelancer.net";
const EMAIL = "info@shopify-freelancer.net";
const TITLE = "Contact, Freelance Shopify Conversion Specialist";
const DESCRIPTION =
  "Send your store URL and get an honest first assessment within 48 hours, free, no sales call, an honest no is possible.";

export const Route = createFileRoute("/en/contact")({
  component: ContactEn,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}/en/contact` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: `${SITE}/en/contact` },
      { rel: "alternate", hrefLang: "de", href: "https://shopify-freelancer.net/kontakt" },
      { rel: "alternate", hrefLang: "en", href: "https://shopify-freelancer.net/en/contact" },
      { rel: "alternate", hrefLang: "x-default", href: "https://shopify-freelancer.net/kontakt" },
      { rel: "alternate", hrefLang: "de", href: `${SITE}/kontakt` },
      { rel: "alternate", hrefLang: "en", href: `${SITE}/en/contact` },
    ],
  }),
});

function ContactEn() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeaderEn />
      <main>
        <section className="veil border-b border-border/60 py-16 md:py-20">
          <div className="mx-auto grid max-w-5xl gap-10 px-5 md:grid-cols-2 md:items-center">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.34em] text-primary">
                Contact
              </p>
              <h1 className="mt-5 text-4xl font-bold leading-[1.08] md:text-5xl">
                Send me your <span className="text-signal">store URL</span>
              </h1>
              <p className="mt-5 text-muted-foreground">
                 Within 48 hours you get a personal assessment, the most sensible next step and,
                 where possible, a cost range. Free and without a sales call.
              </p>
              <div className="mt-6 border-l-2 border-primary pl-4">
                <p className="text-sm font-semibold">Experience from real Shopify stores</p>
                <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                  Work for Lunu, kremka, MASKABEL, Snyder Golf and Logo-Matten. You speak directly
                  with Nicolai Schnepf, who also does the work.
                </p>
              </div>
              <a
                href={`mailto:${EMAIL}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary"
              >
                <Mail className="h-4 w-4" />
                {EMAIL}
              </a>
            </div>
            <LeadForm source="en-contact" compact={false} lang="en" headline="Get a free assessment" />
          </div>
        </section>
      </main>
      <SiteFooterEn />
    </div>
  );
}
